import { useGetAllNonLegacyProductsQuery } from '../../api/product/productApiSlice';
import { isBookableProduct, isMultiLevelProduct, type Product } from '../../checkout/redux/types';

type ProductPriceDetail = { productId: string; level?: string; price: number; currency?: string };

export function usePriceFetching(): ProductPriceDetail[] {
    const { data: products = [] } = useGetAllNonLegacyProductsQuery();
    return products.flatMap(mapProductToPriceDetails);
}

function mapProductToPriceDetails(product: Product): ProductPriceDetail[] {
    if (isBookableProduct(product)) {
        return [{ productId: product.sku, level: product.level, price: product.price, currency: product.currency }];
    }
    if (isMultiLevelProduct(product)) {
        return product.levels.map(level => ({
            productId: product.sku,
            level: level.level,
            price: level.price,
            currency: level.currency,
        }));
    }
    return [];
}
